import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'open_with_faire-owf_soft_credit_check_modal_view-view';
/**
 * Track when the &#x60;Learn more&#x60; modal for the soft credit check disclaimer is viewed
 */
export function trackOpenWithFaireOwfSoftCreditCheckModalViewView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
